import { Box, Typography } from "@mui/material";

const Title = () => {
  return (
    <Typography variant="h1" fontSize="36px">
      <Box
        component="span"
        color="white"
        borderRadius="4px 0 0 4px"
        style={{
          textTransform: "capitalize",
          background: "#3ecf8e",
          paddingLeft: "1rem",
          paddingRight: "0.5rem",
        }}
      >
        Supa
      </Box>
      <Box
        component="span"
        color="white"
        borderRadius="0 4px 4px 0"
        style={{
          textTransform: "capitalize",
          background: "#1976d2",
          paddingLeft: "0.5rem",
          paddingRight: "1rem",
        }}
      >
        Board
      </Box>
    </Typography>
  );
};

export default Title;
